import { DEFAULT_PER_PAGE } from 'mdc-constants';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const useParsePaginationFromUrl = () => {
  const router = useRouter();

  const currentPage = useMemo<number>(() => {
    if (typeof router?.query?.page === 'string') {
      return parseInt(router?.query?.page, 10);
    }

    return 1;
  }, [router?.query?.page]);

  const orderBy = useMemo<string | undefined>(() => {
    if (typeof router?.query?.orderBy === 'string') {
      return router?.query?.orderBy;
    }

    return undefined;
  }, [router?.query?.orderBy]);

  const currentPerPage = useMemo<number>(() => {
    if (typeof router?.query?.perPage === 'string') {
      return parseInt(router?.query?.perPage, 10);
    }

    return DEFAULT_PER_PAGE;
  }, [router?.query?.perPage]);

  return {
    currentPage,
    currentPerPage,
    orderBy,
  };
};
